<ng-container *ngIf="comoUser && comoUser.punch_cards && comoUser.punch_cards.length > 0">
  <div class="max-w-md mx-auto px-5 lg:max-w-full lg:px-0">
    <div class="mb-3">
      <div
        class="flex flex-row py-4 px-4.5 border-neutral-400 border text-neutral-800 rounded rounded-s"
      >
        <div class="flex flex-col">
          <div
            *ngFor="let punchCard of comoUser.punch_cards; let last = last"
            [ngClass]="{
              'border-b border-neutral-300 pb-2 mb-4': last === false,
            }"
          >
            <div class="flex flex-row items-center">
              <div
                class="pr-3 flex-shrink-0"
                *ngIf="punchCard.image"
              >
                <img
                  [src]="punchCard.image"
                  width="52"
                  height="52"
                  class="rounded-full"
                />
              </div>
              <div class="">
                <div class="font-base font-bold text-base lg:text-md">
                  {{ punchCard.name }}
                </div>
                <div class="font-base text-neutral-600 text-sm lg:text-base pt-1">
                  {{ punchCard.description }}
                </div>
                <div class="flex flex-row pt-2">
                  <div
                    *ngFor="
                      let punchIndex of [].constructor(punchCard.required_punches);
                      let i = index
                    "
                  >
                    <i
                      *ngIf="punchCard.punches > i"
                      class="punched icon icon-check-circle text-success-600 mt-1 mr-1 text-xl"
                    ></i>
                    <div
                      *ngIf="punchCard.punches <= i"
                      class="w-5 h-5 mt-1 mr-1 bg-neutral-400 rounded-full"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
